import * as actionTypes from "./actionTypes";
// import { bannerData } from "../../data";
import { firebase } from "../../firebase/index";
import {
  collections,
  constants,
  documents,
} from "../../firebase/firestoreNameSpaces";
import {
  generateUniqueId,
  uploadImage,
  deleteFileFromUrl,
  shuffleArray,
} from "../utility";

export const fetchBanner = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.FETCH_BANNER, payload: { loading: true } });
      let db = firebase.firestore();
      let data = (
        await db.collection(collections.K5METADATA).doc(documents.BANNER).get()
      ).data();
      let banner = [];
      for (let id in data) {
        banner.push(data[id]);
      }
      // banner = shuffleArray(banner)
      dispatch({
        type: actionTypes.FETCH_BANNER,
        payload: { bannerData: banner, loading: false },
      });
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_BANNER,
        payload: { bannerData: null, loading: false },
      });
      // return alert(error)
    }
  };
};

export const onAddBanner = (banner) => {
  return async (dispatch, getState) => {
    dispatch({
      type: actionTypes.BANNER_CONTROLS,
      payload: { addBtnLoading: true },
    });

    try {
      let banners = getState().banner.bannerData;
      let bannerData = [];
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { addBtnLoading: true },
      });
      let image = banner.imgUrl;
      let { imgTitle, redirectUrl } = banner;
      //###########
      let path = `banner/${generateUniqueId(6)}${image.name}`;
      let url = await uploadImage(path, image);
      let id = generateUniqueId(10);
      let bannerObj = {
        id: id,
        imgUrl: url,
        redirectUrl: redirectUrl,
        imgTitle: imgTitle,
      };
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BANNER)
        .set({ [id]: bannerObj }, { merge: true });
      if (banners.length) {
        bannerData = [...banners, bannerObj];
      } else {
        bannerData.push(bannerObj);
      }
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { addBtnLoading: false, bannerData: bannerData },
      });
      // window.location.reload()
      return alert("Banner Added Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { addBtnLoading: false },
      });
      return alert(error);
    }
  };
};
export const onEditBanner = (editedBanner, oldBannerArray) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { bannerBtnLoading: true },
      });

      let id = editedBanner.id;
      let db = firebase.firestore();
      let banners = (
        await db.collection(collections.K5METADATA).doc(documents.BANNER).get()
      ).data();
      for (let ckey in banners) {
        if (ckey != id && banners[ckey].imgTitle == editedBanner.imgTitle) {
          dispatch({
            type: actionTypes.BANNER_CONTROLS,
            payload: { bannerBtnLoading: false },
          });
          return alert(
            "Image Title already exists. Please Select Different Image Title"
          );
        }
      }
      if (editedBanner.image) {
        let path = `banner/${generateUniqueId(6)}${editedBanner.image.name}`;
        let url = await uploadImage(path, editedBanner.image);
        await deleteFileFromUrl(editedBanner.imgUrl);
        editedBanner.imgUrl = url;
        delete editedBanner["image"];
      }
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BANNER)
        .set({ [id]: editedBanner }, { merge: true });
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { bannerBtnLoading: false },
      });
      window.location.reload();
    } catch (error) {
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { bannerBtnLoading: false },
      });
      return alert(error);
    }
  };
};
export const onDeleteBanner = (banner) => {
  return async (dispatch, getState) => {
    try {
      let banners = getState().banner.bannerData;
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { deleteBtnLoading: true },
      });

      //########
      let db = firebase.firestore();
      await db
        .collection(collections.K5METADATA)
        .doc(documents.BANNER)
        .set(
          { [banner.id]: firebase.firestore.FieldValue.delete() },
          { merge: true }
        );
      await deleteFileFromUrl(banner.imgUrl);
      document.getElementById(`cpd${banner.id}`).click();
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: {
          deleteBtnLoading: false,
          bannerData: banners.filter((ca) => ca.id != banner.id),
        },
      });
      return alert("Banner Deleted Successfully");
    } catch (error) {
      dispatch({
        type: actionTypes.BANNER_CONTROLS,
        payload: { deleteBtnLoading: false },
      });
      return alert(error);
    }
  };
};
